export default __webpack_public_path__ + "static/media/tempel view (1)@2x.36c5b97b.png";